// babel.config.js
let wsurl = process.env.VUE_APP_WSURL;
if(wsurl) {
    if(wsurl.indexOf('http') < 0)
         wsurl = `http://${wsurl}${process.env.VUE_APP_WEBMMS_PORT && process.env.VUE_APP_WEBMMS_PORT != 80 ? ':' + process.env.VUE_APP_WEBMMS_PORT : ''}`;
    else
         wsurl = `${wsurl}${process.env.VUE_APP_WEBMMS_PORT && process.env.VUE_APP_WEBMMS_PORT != 80 ? ':' + process.env.VUE_APP_WEBMMS_PORT : ''}`;
}else{
    wsurl = "http://127.0.0.1";
}
console.log(process.env);
console.log(wsurl);
const config =  {
    "wsurl": wsurl.trim(),
    //"wsurl": "http://localhost:85",
    "objstore": ">svc/objc",
    "s3api": "https://s3.ypcloud.com",
    "s3url": "https://s3.ypcloud.com/upload",
    "loginurl": "https://account.ypcloud.com/auth/verify/?ReturnURL=https://jbuilder.ypcloud.com/callback",
    //"loginurl": "https://account.ypcloud.com/auth/verify/?ReturnURL=http://localhost:8081/callback",
    "logouturl": "https://account.ypcloud.com/auth/logout/?ReturnURL=https://jbuilder.ypcloud.com/",
    //"logouturl": "https://account.ypcloud.com/auth/logout/?ReturnURL=http://localhost:8081"
}

export default config;
